import { DefaultTheme } from 'styled-components';
import { dark, gxDark, gxLight, light } from '@mews/design-tokens';
import { ComponentsProps, Theme, ThemeVariant } from '@optimus-web/common';

const defaultComponentsProps: ComponentsProps = {
    Autocomplete: { size: 'medium' },
    Button: { size: 'medium' },
    IconButton: { size: 'medium' },
    ListItem: { dense: false },
    Checkbox: { size: 'medium' },
    Select: { size: 'medium' },
    Input: { size: 'medium' },
    Stepper: { size: 'medium' },
    NumberInput: { size: 'medium' },
};

interface CreateTheme {
    themeVariant?: ThemeVariant;
    tokenOverrides?: Partial<Theme>;
    componentsProps?: Partial<ComponentsProps>;
}

export const createTheme = ({ themeVariant, tokenOverrides = {}, componentsProps }: CreateTheme): DefaultTheme => {
    const getThemeVariant = (variant?: ThemeVariant) => {
        switch (variant) {
            case 'light':
                return light;
            case 'dark':
                return dark;
            case 'gxLight':
                return gxLight;
            case 'gxDark':
                return gxDark;
            default:
                return light;
        }
    };
    const tokens = getThemeVariant(themeVariant);
    const finalTokens = {
        ...tokens,
        ...tokenOverrides,
    };

    return {
        settings: {
            rootSize: 16,
            componentsProps: { ...defaultComponentsProps, ...componentsProps },
        },
        tokens: finalTokens,
        themeVariant: themeVariant || 'light',
    };
};

export const DENSE_LIGHT_THEME = createTheme({
    themeVariant: 'light',
});

export const DENSE_DARK_THEME = createTheme({
    themeVariant: 'dark',
});

export const DENSE_GX_LIGHT_THEME = createTheme({
    themeVariant: 'gxLight',
});

export const DENSE_GX_DARK_THEME = createTheme({
    themeVariant: 'gxDark',
});
